import { render } from "./Agreement4.vue?vue&type=template&id=6d4acbd2"
import script from "./Agreement4.vue?vue&type=script&lang=js"
export * from "./Agreement4.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sung-hojang/git-projects/blackpay-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__